<template>
  <v-container :class="'mt-0 pt-0 '" fluid>
    <v-card class="pa-0 ma-0 mt-5 mb-5" elevation="0">
      <v-row>
        <v-col cols="3" class="my-0 py-0">
          <SelectFilter
            class="mb-0 pb-0"
            :label="this.$t('cards.banks')"
            :get-request="this.$axios.banks"
            item-text="bankName"
            item-value="bankId"
            :selectedItem="bankFilterArray"
            :prepend-icon="'mdi-bank'"
            :disabled="2"
            notMultiple
            v-on:changed="(items) => (this.bankFilterArray = items)"
          />
        </v-col>
        <v-col cols="3" class="my-0 py-0">
          <v-text-field
            class="mb-0 pb-0"
            :label="this.$t('cards.products')"
            :value="productFilter"
            @change="(v) => (productFilter = v)"
            :append-icon="'mdi-close'"
            @click:append="() => (productFilter = '')"
            :prepend-icon="'mdi-alpha-p-circle-outline'"
          />
        </v-col>
        <v-col class="my-0 py-0" cols="3">
          <combobox-filter2000
            class="mb-0 pb-0"
            v-model="statusTypesFilterArray"
            :label="this.$t('referenceBooks.products.Status')"
            :items="statusTypes"
            itemText="statusName"
            itemValue="statusId"
            translate
            :localizationFunc="
              (val) => $t('productStatusNames.statusName' + val.statusId)
            "
            :prepend-icon="'mdi-clock-outline'"
            style="z-index: 200"
          />
        </v-col>
        <v-col cols="1" class="my-0 py-0"></v-col>
        <v-col cols="2" class="my-0 py-0">
          <v-row>
            <v-spacer />
            <SearchButtons
              v-on:clear="clearFilters"
              v-on:get="() => getData('search')"
            />
          </v-row>
        </v-col>
        <v-spacer />
      </v-row>
    </v-card>
    <v-card>
      <v-card-title class="mt-3 my-0 pb-1 pt-2">
        <ProductDialog
          v-if="this.$store.getters.CAN_ADD_PRODUCTS"
          :mode="0"
          :bank="bankParam"
          v-on:created="onCreated"
          v-on:error="onError"
        />
        <ProductDialog
          v-if="this.$store.getters.CAN_EDIT_PRODUCTS && isActive"
          :mode="1"
          :product="selectedProduct[0]"
          v-on:saved="onSaved"
          v-on:error="onError"
        />
        <Confirm
          v-if="this.$store.getters.CAN_DELETE_PRODUCTS && isActive"
          :disabled="this.$store.getters.CAN_DELETE_PRODUCTS"
          :title="deleteConfirmTitle"
          :text="confirmText"
          :tooltipText="$t('confirm.deleteProduct')"
          v-on:ok="onDelete"
        />
        <Confirm
          v-if="this.$store.getters.CAN_DELETE_PRODUCTS && isNotActive"
          :disabled="this.$store.getters.CAN_DELETE_PRODUCTS"
          :title="restoreConfirmTitle"
          :tooltipText="$t('confirm.restoreProduct')"
          v-on:ok="onRestore"
          iconName="mdi-restore"
        />
        <v-spacer />
        {{ $t("cards.total") }}: {{ totalCount }}
      </v-card-title>
      <LoadIcon v-if="loading" />
      <LightTable
        :headers="headers"
        :items="products"
        :loading="loading"
        itemKey="productId"
        :selectedItems="selectedProduct"
        :markedItems="changedProductsId"
        :no-data-text="noDataText"
        singleSelect
        defaultSortColumn="productName"
        :sortBy="sortBy"
        :sortDesc="sortDesc"
        v-on:changedSortDesc="onChangeSortDesc"
        v-on:changedSort="onChangeSort"
        v-on:update="onUpdate"
        :height="tableHeight"
      />
    </v-card>
  </v-container>
</template>

<script>
import Vue from 'vue';
import ComboboxFilter2000 from '@/components/FiltersComponent/ComboboxFilter2000';
import SearchButtons from '../components/FiltersComponent/SearchButtons';
import ProductDialog from '@/components/Dialogs/ProductDialog';
import SelectFilter from '../components/FiltersComponent/SelectFilter';
import LoadIcon from '@/components/LoadIcon';
import Confirm from '@/components/Confirm';
import LightTable from '@/components/Tables/LightTable';
import { notifyError, notifySuccess } from '@/services/notifications';
import tableHeightMixin from './mixins/tableHeightMixin';
import valIsNull from '@/services/valIsNull';

export default {
  name: 'Products',
  mixins: [tableHeightMixin],
  components: {
    ProductDialog,
    LoadIcon,
    Confirm,
    SelectFilter,
    LightTable,
    SearchButtons,
    ComboboxFilter2000,
  },
  data() {
    return {
      limit: 10,
      page: 1,
      totalCount: '0',

      // Для расчёта высоты таблицы
      offsetHeight: this.$store.getters.HEIGHT_OFFSET,
      headerH: 48,
      filterH: 56,
      tHeaderH: 44,
      tFooterH: 62,

      productFilter: '',
      bankFilterArray: [],
      statusTypesFilterArray: [],
      statusTypes: [],

      sortBy: [],
      sortDesc: [],
      tempProducts: [],

      changedProductsId: [],
      selectedProduct: [],
      products: [],
      loading: false,
      noData: false,

      apiUri: 'http://192.168.1.231/api',
    };
  },
  watch: {
    filterJson() {
      this.getData('FilterJson');
    },
    statusTypesFilterArray() {
      if (
        this.statusTypesFilterArray === null ||
        this.statusTypesFilterArray.length === 0
      )
        this.setActiveStatusesForFilter();
    },
  },
  computed: {
    isActive() {
      return (
        this.selectedProduct.length === 1 &&
        this.selectedProduct[0].statusId === 1
      );
    },
    isNotActive() {
      return (
        this.selectedProduct.length === 1 &&
        this.selectedProduct[0].statusId === 2
      );
    },
    propertiesResponse() {
      return { Devices: this.$t('errorsMessages.ProductAttachWithDevice') };
    },
    bankParam() {
      return this.bankFilterArray == null || this.bankFilterArray.length == 0
        ? null
        : this.bankFilterArray;
    },
    deleteConfirmTitle() {
      return (
        this.$t('confirm.deleteProduct') +
        ' ' +
        this.selectedProduct[0].productName +
        '?'
      );
    },
    restoreConfirmTitle() {
      return (
        this.$t('confirm.restoreProduct') +
        ' ' +
        this.selectedProduct[0].productName +
        '?'
      );
    },
    confirmText() {
      return this.$t('confirm.text');
    },
    headers() {
      const result = [
        { text: '', value: '0', sortable: false },
        {
          text: this.$t('referenceBooks.banks.Name'),
          value: 'bankName',
          sortable: true,
        },
        {
          text: this.$t('referenceBooks.products.Name'),
          value: 'productName',
          sortable: true,
        },
        {
          text: this.$t('referenceBooks.products.Link'),
          value: 'link',
          sortable: true,
        },
        {
          text: this.$t('referenceBooks.products.Alias'),
          value: 'alias',
          sortable: true,
        },
      ];
      if (
        this.$store.getters.RIGHTS_ON_BANK_LEVEL ||
        this.$store.getters.RIGHTS_ON_BRANCH_LEVEL
      )
        result.splice(0, 1);

      return result;
    },
    noDataText() {
      return this.$t('cards.noData');
    },
    filterJson() {
      const result = {};

      result.productName = !this.productFilter ? '' : this.productFilter;
      result.banksId =
        this.bankFilterArray == null || this.bankFilterArray.length == 0
          ? []
          : [this.bankFilterArray.bankId];
      result.statusId =
        this.statusTypesFilterArray == null ||
        this.statusTypesFilterArray.length == 0
          ? []
          : this.statusTypesFilterArray.map((val) => val.statusId);

      return result;
    },
  },
  methods: {
    setActiveStatusesForFilter() {
      this.statusTypesFilterArray = this.statusTypes.filter(
        (val) => val.statusId === 1
      );
    },
    onUpdate(items) {
      this.selectedProduct = items;
      this.changedProductsId = [];
    },
    checkFilters() {
      return (
        (this.bankFilterArray == null || this.bankFilterArray.length == 0) &&
        (this.productFilter == null || this.productFilter.length == 0)
      );
    },
    clearFilters() {
      this.bankFilterArray = [];
      this.productFilter = '';
      this.setActiveStatusesForFilter();
      this.getData('clearFilters');
    },
    async getData() {
      this.loading = true;
      this.selectedProduct = [];

      const params = {
        query: JSON.stringify(this.filterJson),
      };
      this.getCount(params);
      params.limit = await this.limit;
      params.offset = (await this.limit) * (this.page - 1);
      this.executeRequest(params);
    },
    async getCount(params) {
      this.$axios.products
        .getCount(params)
        .then((response) => response.data)
        .then((json) => {
          this.paginationLength = Math.ceil(json.totalCount / this.limit);
          this.totalCount = json.totalCount;
        })
        .catch((error) => {
          this.onError(
            error,
            this.$t('referenceBooks.products.GetFailedCount')
          );
        });
    },
    async executeRequest(params) {
      this.$axios.products
        .get(params)
        .then((response) => response.data)
        .then((json) => {
          this.tempProducts = this.sortData(json, this.sortBy, this.sortDesc);
          this.products = this.tempProducts.slice(0, 500);
          this.loading = false;
          this.noData = this.products == null || this.products.length == 0;
        })
        .catch((error) => {
          this.onError(error, this.$t('referenceBooks.products.GetFailed'));
          this.loading = false;
        });
    },
    onChangeSort(sort) {
      this.sortBy = sort;

      if (this.sortDesc.length === this.sortBy.length)
        this.products = this.sortData(
          this.tempProducts,
          this.sortBy,
          this.sortDesc
        ).slice(0, 500);
    },
    onChangeSortDesc(sortDesc) {
      this.sortDesc = sortDesc;

      if (this.sortDesc.length === this.sortBy.length)
        this.products = this.sortData(
          this.tempProducts,
          this.sortBy,
          this.sortDesc
        ).slice(0, 500);
    },
    sortData(items, sortBy, desc) {
      items.sort(function(a, b) {
        let index = 0;

        while (index < sortBy.length) {
          const isDesc =
            desc !== null && desc[index] !== null && desc[index] === true
              ? true
              : false;

          if (valIsNull(a[sortBy[index]]) && valIsNull(b[sortBy[index]]))
            return 0;
          if (valIsNull(a[sortBy[index]])) return isDesc ? -1 : 1;
          if (valIsNull(b[sortBy[index]])) return isDesc ? 1 : -1;

          if (a[sortBy[index]] > b[sortBy[index]]) return isDesc ? -1 : 1;
          if (a[sortBy[index]] < b[sortBy[index]]) return isDesc ? 1 : -1;
          index++;
        }

        return 0;
      });

      return items;
    },
    setDefaultSort() {
      if (
        this.$store.getters.RIGHTS_ON_BANK_LEVEL ||
        this.$store.getters.RIGHTS_ON_BRANCH_LEVEL
      ) {
        this.sortBy = ['productName'];
        this.sortDesc = [false];
      } else {
        this.sortBy = ['bankName', 'productName'];
        this.sortDesc = [false, false];
      }
    },
    async onDelete() {
      const product = this.selectedProduct[0];
      await this.$axios.products
        .delete(product.productId)
        .then((response) => {
          if (response.status == 200) {
            notifySuccess(
              '',
              this.$t('Messages.ProductWasDeleted', [product.productName])
            );
            this.selectedProduct = [];
          } else
            this.showMessage(
              this.$t('Deleted'),
              `${this.$t('referenceBooks.products.Name')}: ${
                product.productName
              }\n${this.$t('Status')}: ${response.status}`,
              'warn'
            );
          this.getData('OnDelete');
        })
        .catch((error) => {
          console.error(error);

          notifyError(this.$t('Error'), error);
          this.catchError(
            error,
            product.productName,
            this.$t('errorsMessages.Delete')
          );
        });
    },
    async onRestore() {
      const product = this.selectedProduct[0];
      await this.$axios.products
        .restore(product.productId)
        .then((response) => {
          if (response.status == 200) {
            notifySuccess(
              '',
              this.$t('Messages.ProductWasRestored', [product.productName])
            );
            this.selectedProduct = [];
          } else
            this.showMessage(
              this.$t('Restored'),
              `${this.$t('referenceBooks.products.Name')}: ${
                product.productName
              }\n${this.$t('Status')}: ${response.status}`,
              'warn'
            );
          this.getData('OnRestore');
        })
        .catch((error) => {
          console.error(error);

          notifyError(this.$t('Error'), error);
          this.catchError(
            error,
            product.productName,
            this.$t('errorsMessages.Restore')
          );
        });
    },
    catchError(error, name, errorHeader = '') {
      console.error(error);
      const status = error.response.status;
      const data = [error.response.data];

      const errorHeaderActual =
        errorHeader === '' ? this.$t('Error') : errorHeader;

      if (status === 400 || status === 401) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].errorType === 'HAS_RELATIONS') {
            this.showMessage(
              `${errorHeaderActual}`,
              `${this.propertiesResponse[data[i].property]}<br>${this.$t(
                'referenceBooks.products.Name'
              )}: ${name}`,
              'error'
            );
          } else if (data[i].errorType === 'NO_RIGHTS') {
            this.showMessage(
              `${errorHeaderActual}`,
              `${this.$t('errorsMessages.NoRights')}`,
              'error'
            );
          } else this.showMessage(errorHeaderActual, error, 'error');
        }
      } else {
        this.showMessage(errorHeaderActual, error, 'error');
      }
    },
    markRow(id) {
      this.changedProductsId = [];
      this.changedProductsId.push(id);
    },
    async onCreated(status, productName, id) {
      this.getData('onCreated');
      if (status == 200)
        this.showMessage(
          this.$t('referenceBooks.products.created'),
          `${this.$t('referenceBooks.products.Name')}: ${productName}`
        );
      else
        this.showMessage(
          this.$t('referenceBooks.products.created'),
          `${this.$t(
            'referenceBooks.products.Name'
          )}: ${productName} '\n${this.$t('Status')}: + ${status}`,
          'warn'
        );

      this.markRow(id);
    },
    async onSaved(status, product) {
      this.getData('onSaved');
      if (status == 200)
        this.showMessage(
          this.$t('referenceBooks.ChangedSaved'),
          `${this.$t('referenceBooks.products.Name')}: ${product.productName}`
        );
      else
        this.showMessage(
          this.$t('referenceBooks.ChangedSaved'),
          `${this.$t('referenceBooks.products.Name')}: ${
            product.productName
          } '\n${this.$t('Status')}: + ${status}`,
          'warn'
        );

      this.markRow(product.productId);
    },
    async onError(error, errorHeader = '') {
      this.catchError(error, null, errorHeader);
    },
    showMessage(title, text, type = '') {
      Vue.notify({
        group: 'notif',
        title: title,
        text: text,
        type: type,
      });
    },
  },
  async mounted() {
    await this.$axios.products
      .getStatuses()
      .then((response) => {
        return response.data;
      })
      .then((json) => {
        this.statusTypes = json;
      })
      .catch((error) => {
        console.error(error);
        this.statusTypes.push(
          { statusName: '123', productStatusId: 1 },
          { statusName: '321', productStatusId: 2 }
        );
      });
    this.setActiveStatusesForFilter();
    this.getData('mounted');
  },
};
</script>

